export default __webpack_public_path__ + "static/media/Horizontal Escuro.a34b8e4d.svg";